export default __webpack_public_path__ + "static/media/footer-desktop.f5701621.jpg";